{
  "loading": "Chargement...",
  "error": "Erreur",
  "cancel": "Annuler",
  "confirm": "Confirmer",
  "close": "Fermer",
  "open": "Ouvrir",
  "ok": "OK",
  "yes": "Oui",
  "no": "Non",
  "continue": "Continuer",
  "back": "Retour",
  "next": "Suivant",
  "finish": "Terminer",
  "save": "Enregistrer",
  "delete": "Supprimer",
  "edit": "Modifier",
  "create": "Créer",
  "update": "Mettre à jour",
  "refresh": "Actualiser",
  "success": "Succès",
  "warning": "Avertissement",
  "info": "Information",
  "search-placeholder": "Rechercher...",
  "message-input": "Entrez votre message...",
  "please-log-in-to-access-this-page": "Veuillez vous connecter pour accéder à cette page",
  "go-to-settings": "Aller aux Paramètres",
  "go-back": "Retour",
  "welcome-user": "Bienvenue, {$username} !",
  "notification-count": "{$count ->\n   [0] Aucune notification\n   [1] Une notification\n   *[other] {$count} notifications\n  }",
  "user-offline": "utilisateur hors ligne",
  "user-offline-message": "{$source ->\n   [streamer] On dirait que <1>@{$handle} est hors ligne</1>, mais ils recommandent de regarder :\n   *[default] On dirait que <1>@{$handle} est hors ligne</1>, mais nous recommandons de regarder :\n  }",
  "user-offline-no-recommendations": "On dirait que <1>@{$handle} est hors ligne</1> maintenant.\nRevenez plus tard.",
  "streaming-title": "diffusion de {$title}",
  "viewer-count": "{$count ->\n   [0] 0 spectateurs\n   [1] 1 spectateur\n   *[other] {$count} spectateurs\n  }",
  "pds-selector-title": "Nouveau sur Atmosphere ?",
  "pds-selector-description": "Vous devrez sélectionner un PDS (Serveur de Données Personnel) pour accéder aux applications sur Atmosphere, comme Bluesky, Tangled et Spark.",
  "pds-selector-custom-label": "Un autre PDS",
  "pds-selector-custom-description": "Saisissez l'URL de votre propre hôte PDS",
  "pds-selector-custom-url-label": "URL PDS personnalisée",
  "pds-selector-custom-url-placeholder": "https://pds.exemple.com",
  "pds-selector-learn-more": "En savoir plus sur l'auto-hébergement",
  "pds-selector-info": "Chaque hôte a ses propres politiques et normes de fiabilité. Vos données ATProto se trouvent sur l'hôte que vous choisissez et vous pouvez migrer ultérieurement. Remarque : Streamplace a ses propres règles de modération — vous pouvez être banni de Streamplace quel que soit l'hôte choisi.",
  "pds-selector-read-policies": "Lisez les <tosLink>Conditions d'utilisation</tosLink> et la <privacyLink>Politique de confidentialité</privacyLink> de {$label} avant de continuer.",
  "pds-selector-handle-policy-checkbox": "J'ai lu et j'accepte la <policyLink>politique des identifiants</policyLink>",
  "login-show-live-on-bluesky": "Afficher quand je suis en direct sur Bluesky",
  "login-show-live-on-bluesky-description": "Ajoute l'anneau rouge LIVE à votre avatar Bluesky pendant vos streams et permet à Streamplace de publier des annonces pour vous. Décochez la case pour vous connecter sans accorder aucun accès à votre compte Bluesky."
}
